<template>
<div>
  <v-expansion-panel>
    <template v-if="!alertMode">
    <v-expansion-panel-content
      v-for="(item) in filteredAlerts"
      :key="item['.key']"
      expand-icon=""
      :class="item.daysLeft < 0 ? 'went' : 'coming'"
    >
      <div slot="header">
        <b>{{item.buyerName}}</b><br/>
        <b v-if="item.mobile">Contact: {{item.mobile}}</b><br/>
        {{generateAddress(item)}} 
      </div>
      <v-card>
        <v-card-title>
          <div>
          <b>Deposite Amount :</b> {{ item.paidAmount || null }}<br />
          <b>Remaining Amount :</b> {{ item.remainingAmount || null }}<br />
          <b>Total Amount :</b> {{ item.totalAmount || null }}<br />
          <b>Basic Amount :</b> {{ item.totalAmount -  getGSTtotal(item)|| null }}<br />
          <b>Discount Amount :</b> {{ item.discountAmount || null }}<br />
          <b>GST Amount :</b> {{ getGSTtotal(item) || null }}<br />
          <b>Transaction type :</b> {{ item.transactionType || null }}<br />
          </div>
        </v-card-title>
        <v-card-actions style="padding: 0 16px 16px 16px">
          <v-btn small color="primary white--text" @click ="dialogOpen=true; dialogDetail=item;">View Details</v-btn>
        </v-card-actions>
      </v-card>
    </v-expansion-panel-content>
    </template>

    <template v-else>
    <v-expansion-panel-content
      v-for="(item) in filteredProducts"
      :key="item['.key']"
      expand-icon=""
    >
    <template v-if="(item['alertQuantity'] ? item['closingQty'] <= item['alertQuantity']:item['closingQty'] <= 5)">
      <div slot="header">
        <b>{{item.name}}</b><br/>
      </div>
      <v-card>
        <v-card-title>
          <div>
          <b class="font-weight-light">Quantity :</b> {{ item.closingQty || null }}<br />
          </div>
        </v-card-title>
        <!-- <v-card-actions style="padding: 0 16px 16px 16px">
          <v-btn small color="primary white--text" @click ="dialogOpen=true; dialogDetail=item;">View Details</v-btn>
        </v-card-actions> -->
      </v-card>
      </template>
    </v-expansion-panel-content>
    </template>
  </v-expansion-panel>
  <v-dialog v-model="dialogOpen" max-width="500px">
    <v-card v-if="dialogDetail">
      <v-card-title>
        <b>Invoice Full Detail</b>
        <v-spacer></v-spacer>
        <span>
          <b>
            Days <span v-html="dialogDetail.daysLeft < 0 ? 'Went' : 'Left'"/>
            : {{Math.abs(dialogDetail.daysLeft)}}
          </b>
        </span>
        <v-card-text>
          <b>Name</b> {{dialogDetail.buyerName}}<br/>
          <b>Prop Name :</b> {{ dialogDetail.propName }}<br />
          <b>buyer Id :</b> {{ dialogDetail.buyerId }}<br />
          <b>Village :</b> {{ dialogDetail.village }}<br />
          <b>Block :</b> {{ dialogDetail.block }}<br />
          <b>Tehsil :</b> {{ dialogDetail.tehsil }}<br />
          <b>District :</b> {{ dialogDetail.district }}<br />
          <b>Date :</b> {{ dialogDetail.date }}<br />
          <b>Id :</b> {{ dialogDetail['.key'] }}<br />
          <b>Invoice ID :</b> {{ dialogDetail['invoiceId'] }}<br />
          <b>Firm Name :</b> {{ dialogDetail.firmName }}<br />
          <b>Payment Type :</b> {{ dialogDetail.paymentType }}<br />
          <b>Duration :</b> {{ dialogDetail.duration }} days<br />
          <b>Status :</b> {{ dialogDetail.status }}<br />
          <b>Contact :</b> {{ dialogDetail.mobile }}<br /><br />

          <b>Deposite Amount :</b> {{ dialogDetail.paidAmount || null }}<br />
          <b>Remaining Amount :</b> {{ dialogDetail.remainingAmount || null }}<br />
          <b>Total Amount :</b> {{ dialogDetail.totalAmount || null }}<br />
          <b>Basic Amount :</b> {{ dialogDetail.totalAmount -  getGSTtotal(dialogDetail)|| null }}<br />
          <b>Discount Amount :</b> {{ dialogDetail.discountAmount || null }}<br />
          <b>GST Amount :</b> {{ getGSTtotal(dialogDetail) || null }}<br />
          <!-- <b>Transaction type :</b> {{ dialogDetail.transactionType || null }}<br /> -->


        </v-card-text>
      </v-card-title>
      <v-card-actions>
        <v-btn color="primary white--text" flat @click.stop="dialogOpen=false">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
const mapGlobalGetters = createNamespacedHelpers('Global')['mapGetters']
import { compoundInterest, amountCompound } from '../../utils/'
let brand = window.localStorage.getItem('brand');
export default {
  name: 'AlertSidebar',
  data () {
    return {
      dialogOpen: false,
      dialogDetail: null,
      firms: {},
      buyerById: {},
      invoices: [],
    }
  },
  props: {
   alertMode : Boolean
  },
  created () {
      // this.$bindAsArray(
      //   'invoices',
      //   this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(brand)
      // )
      this.$bindAsObject(
        'buyerById',
        this.$root.$firebaseRefs.buyer
      )
      this.$bindAsObject(
        'sellerById',
        this.$root.$firebaseRefs.seller
      )
      this.$bindAsObject(
        'firms',
        this.$root.$firebaseRefs.firm
      ),
      this.$bindAsArray("products", this.$root.$firebaseRefs.products.orderByChild('brand').equalTo(brand));
  },
  computed: {
    ...mapGlobalGetters(['selectedBrand','finYear']),

    filteredAlerts() {
      if(!this.invoices) {
        return []
      }
      const alertItems = []

      this.invoices.forEach(item => {
        if(item.brand !== this.selectedBrand) {
          return null
        }
        if(item.status === 'paid' || !item.duration || !item.date) {
          return null;
        }

        const invoice = item;
        // calculate value details
        const dt1 = new Date(invoice.date)
        const dt2 = new Date()
        const daysSpent = Math.floor((Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) / (1000 * 60 * 60 * 24))
        
        if(invoice.date) {
          invoice.dateA = dt1.toLocaleDateString('en-GB')
        }
        const daysLeft = invoice.duration - daysSpent;
        
        if(daysLeft <= -5 || daysLeft >= 5) {
          return null;
        }
        // Set Item as AlertList 
        invoice.daysLeft = daysLeft
        invoice.daysSpent = daysSpent

        // set buyer info
        const buyer = this.buyerById[invoice.buyerId] || this.sellerById[invoice.buyerId] || {}
        invoice.buyerName = buyer.name
        invoice.propName = buyer.propName
        invoice.village = buyer.village
        invoice.block = buyer.block
        invoice.tehsil = buyer.tehsil
        invoice.district = buyer.district
        invoice.mobile = buyer.mobile

        if(invoice.firm) {
          const firm = this.firms[invoice.firm]
          invoice.firmName = firm && firm.name
        }
        alertItems.push(item)
      })
      return alertItems
    },
    filteredProducts(){
     let toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      let fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      let products = this.products.filter(item => item['brand'] === this.selectedBrand);
      let total = {
        quantity : 0,
        durationQuantity : 0,
        durationAmount : 0,
        saleQuantity : 0,
        durationQtySale : 0,
        durationAmountSale : 0,
        purchaseQuantity : 0,
        durationQtyPurchase : 0,
        durationAmountPurchase : 0,
        openingQuantity : 0,
        openingBalance : 0
      }
      products.map(p => {
        p["durationQuantity"] = undefined;
        p["durationAmount"] = 0;
        p["durationQtySale"] = 0;
        p["durationQtyPurchase"] = 0;
        p["durationAmountSale"] = 0;
        p["durationAmountPurchase"] = 0;
        p["stockReportData"] = {
        saleDetails : [],
        purchaseDetails : [],
        lastSalePrice : 0,
          lastPurchasePrice : 0
        } 
        if(p.openingBalance && p.openingQuantity) {
          p["stockReportData"]['purchaseDetails'].push({
            // quantity : Number.parseFloat(p.openingQuantity),
            // rate : Number.parseInt(p.openingBalance),
            quantity : Number.parseInt(p.openingQuantity),
            rate : (Number.parseFloat(p.openingBalance)/ Number.parseInt(p.openingQuantity)),
            date: p.openingDate
          })
          p["stockReportData"]['lastPurchasePrice'] = p.openingBalance;
        }
        total.openingQuantity += parseInt(p["openingQuantity"] ? p["openingQuantity"] : 0)
        total.openingBalance +=  Number.parseFloat(p["openingBalance"] ? p["openingBalance"] : 0)
      });
      let productGroup = products.reduce(function(r, a) {
        r[a[".key"]] = r[a[".key"]] || [];
        r[a[".key"]].push(a);
        return r;
      }, Object.create(null));
      let latestSaleDate = new Date('01-01-1000').getTime();
      let latestPurchaseDate = new Date('01-01-1000').getTime();
      let filteredInvoices = this.invoices.filter(item => (      
      (item.type != "automatic invoice") &&
      (item.items && item.items.length) &&
      (item.date >= this.finYear.start) && 
      (item.deleted != true) &&
      (item.date <= this.finYear.end) &&
      (fromDate ? item.date >= fromDate : true) &&
      (toDate ? item.date <= toDate : true)));
      this.selectProdList = [];
      filteredInvoices.map(invoice => {
          let isBuyer = invoice.isBuyer;
          invoice.items &&
            invoice.items.map(item => {
              if(productGroup[item["productId"]]) {
                 if (
                productGroup[item["productId"]][0].durationQuantity != undefined
              ) {
                let durationQuantity = parseInt(
                  productGroup[item["productId"]][0]["durationQuantity"]
                );
                durationQuantity += !!isBuyer
                  ? -parseInt(item.quantity)
                  : parseInt(item.quantity);
                total.durationQuantity += durationQuantity;
                productGroup[item["productId"]][0][
                  "durationQuantity"
                ] = durationQuantity;
              } else {
                productGroup[item["productId"]][0][
                  "durationQuantity"
                ] = productGroup[item["productId"]][0].openingQuantity
                  ? productGroup[item["productId"]][0].openingQuantity
                  : 0;
                  total.durationQuantity += parseInt(productGroup[item["productId"]][0][
                  "durationQuantity"
                ]);
              }
              let rate = (Number.parseFloat(item.rate));
              if(isBuyer) {
                if(invoice.date > latestSaleDate) {
                  latestSaleDate = invoice.date;
                  productGroup[item["productId"]][0]['stockReportData']['lastSalePrice'] = rate;
                }
                productGroup[item["productId"]][0]['stockReportData']['saleDetails'].push({
                  quantity : item.quantity,
                  rate : rate,
                  date : invoice.date
                })
              } else {
                if(invoice.date > latestPurchaseDate) {
                  latestPurchaseDate = invoice.date;
                  productGroup[item["productId"]][0]['stockReportData']['lastPurchasePrice'] = rate;
                }
                productGroup[item["productId"]][0]['stockReportData']['purchaseDetails'].push({
                  quantity : item.quantity,
                  rate : rate,
                  date : invoice.date
                })
              }
              productGroup[item["productId"]][0]["durationAmount"] += !!isBuyer
                ? -Number.parseFloat(item.basicPrice) + Number.parseFloat(item.GSTValue)
                : Number.parseFloat(item.basicPrice) + Number.parseFloat(item.GSTValue);
                total.durationAmount += productGroup[item["productId"]][0]["durationAmount"];
              if (!!isBuyer) {
                productGroup[item["productId"]][0][
                  "durationQtySale"
                ] += parseInt(item.quantity);
                total.durationQtySale += parseInt(item.quantity);
                productGroup[item["productId"]][0][
                  "durationAmountSale"
                ] += (Number.parseFloat(item.basicPrice) + Number.parseFloat(item.GSTValue));
                total.durationAmountSale += Number.parseFloat(item.basicPrice) + Number.parseFloat(item.GSTValue);
              } else {
                productGroup[item["productId"]][0][
                  "durationQtyPurchase"
                ] += parseInt(item.quantity);
                total.durationQtyPurchase += parseInt(item.quantity);
                productGroup[item["productId"]][0][
                  "durationAmountPurchase"
                ] += Number.parseFloat(item.basicPrice) + Number.parseFloat(item.GSTValue);
                total.durationAmountPurchase += Number.parseFloat(item.basicPrice) + Number.parseFloat(item.GSTValue);
              }
              item['date'] = invoice.date;
              item['invoice'] = invoice;
              item['isBuyer'] = invoice['isBuyer'];
              item['openingBalance'] = productGroup[item["productId"]][0]['openingBalance']
              item['openingQuantity'] = productGroup[item["productId"]][0]['openingQuantity']
              if(!(productGroup[item["productId"]][0]['productList'] && productGroup[item["productId"]][0]['productList'].length))
                productGroup[item["productId"]][0]['productList'] = [];

              productGroup[item["productId"]][0]['productList'].push(item)
              }
              
            });
      });
      let results = [];
      Object.keys(productGroup).length &&
        Object.keys(productGroup).map((key, index)=> {
          productGroup[key][".key"] = key;
          results.push(productGroup[key][0]);
          productGroup[key][0]['closingQty'] = this.getClosingQtyt(productGroup[key][0]);
    
        });
      return results;
        
    },
  },
  methods: {
      getClosingQtyt(item) {
      let closingQty = (parseInt(item['openingQuantity'] ? item['openingQuantity'] : 0) + parseInt(item['durationQtyPurchase'] ? item['durationQtyPurchase'] : 0)) - parseInt(item['durationQtySale'] ? item['durationQtySale'] : 0)
    
      return closingQty;
      
    },
    generateAddress(user) {
      let address =  '' 
      if(user.block) {
        address = `${user.block}`
      }
      if(user.village) {
        address = `${address ? address + ', ' : ''}${user.village}`
      }
      if(user.tehsil) {
        address = `${address ? address + ', ' : ''}${user.tehsil}`
      }
      if(user.state) {
        address = `${address ? address + ', ' : ''}${user.state}`
      }
      return address;
    },
    getGSTtotal(item){
      let GSTTotal = 0;
      item && item.items && item.items.map((item)=>{
        GSTTotal += Number.parseFloat(item.GSTValue);
      })
      return GSTTotal;
    }
  } ,
}
</script>
<style scoped>
.theme--light.v-expansion-panel .v-expansion-panel__container.went {
  background-color: rgba(0,0,0, 0.3)
}
</style>
<style>
.v-expansion-panel__header {
  padding: 8px 16px;
}
</style>


// WEBPACK FOOTER //
// src/components/Home/AlertSidebar.vue